import { useState, useEffect, memo } from 'react';
import {
  BodyText,
  BodyTextBold,
  SmallHeightDivider,
  StyledButtonOutlined,
  StyledButton,
  MediumHeightDividers,
  MediumHeightDivider
} from '../../../theme/Styles';
import {
  Container,
} from '../styles/FormStyles';
import { localToArray } from '../../../utilities/functions/ArrayUtil';
import { useFormik } from 'formik';
import * as  yup from 'yup';
import { getFieldValidation } from '../FormFunctions';
import RenderField from '../components/RenderField';
import { localToString } from '../../../utilities/functions/StringUtil';
import { localToObject } from '../../../utilities/functions/ObjectUtil';
import FormModal from '../../../components/FormModal/FormModal';
import { Grid } from '@mui/material';
import { FIELD_TYPES } from '../FormConstants';
import deepEqual from 'deep-equal';
import { useSnackbar } from "notistack";
function ModalForm(props) {
  const [state, setState] = useState({});
  const [schemaValidation, setSchemaValidation] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const listIndex = localToObject(props.isVisible).listIndex
  const isModifying = listIndex !== undefined
  const { errors, setFieldTouched, setFieldValue, values, touched, handleSubmit, resetForm } = useFormik({
    initialValues: state,
    onSubmit: (values, actions) => {
      localDoRequest({ values, actions })
    },
    validationSchema: yup.object().shape(schemaValidation),
    enableReinitialize: true,
  });

  useEffect(() => {
    if (props.isVisible && localToArray(props.fields).length > 0) {
      const innerState = { ...state, ...localToObject(props.isVisible) }
      const innerSchema = {}
      props.fields.map((field) => {
        const validator = getFieldValidation(field)
        if (validator) {
          innerSchema[field.fieldKey] = getFieldValidation(field)
        }
        if (!innerState[field.fieldKey]) {
          innerState[field.fieldKey] = undefined
        }
      })
      setState(innerState)
      setSchemaValidation(innerSchema)
    }
    return () => { }
  }, [props.isVisible, props.fields])

  useEffect(() => {
    if (!props.isVisible) {
      resetForm()
      setState({})
    }
    return () => { }
  }, [props.isVisible])

  const localDoRequest = ({ values, actions }) => {
    const value = localToArray(props.value);
    const currentFormValues = values;
    if (currentFormValues?.listIndex)
      delete currentFormValues.listIndex
    let canInsertData = true;
    for (let i = 0; i < value.length; i++) {
      const currentElement = value[i];
      if (deepEqual(currentFormValues, currentElement)) {
        //TODO SHOW ERROR
        canInsertData = false;
        enqueueSnackbar("Este registro ya se encuentra.", { variant: 'error' })

        break;
      }
    }
    if (canInsertData) {
      props.doRequest({ values, fatherKey: props.fatherKey, listIndex })
    }
  }

  //TO DO ENHANCE THIS FUNCTION BECAUSE IF SELECT1 HAS SELECTED ID:001 IN THE SELECT2 THE OPTION 001 WILL BE DISABLED IF SELECT1 AND SELECT2 HAVE MASK 25 IS PREFFERED ONLY 1 PREVENTDATA SELECT PER GRID
  const handleSelectPreventOptions = () => {
    const values = localToArray(props.value)
    let filteredValues = [];
    const selectsFieldList = props.fields.filter(field => field.type === FIELD_TYPES.select && field.Mask === '24');
    for (let i = 0; i < selectsFieldList.length; i++) {
      const selectField = selectsFieldList[i];
      for (let i = 0; i < values.length; i++) {
        const element = values[i][selectField?.fieldKey];
        filteredValues.push(element)
      }
    }
    return filteredValues;
  }

  const selectPreventOptions = handleSelectPreventOptions();

  const LocalRenderGrid = ({ item, index }) => {
    return (
      <RenderField
        {...item}
        key={item.key}
        fieldKey={item.fieldKey}
        value={values[item.fieldKey]}
        fatherValue={values[localToString(item.father_id)]}
        placeholder={item.placeholder}
        error={touched[item.fieldKey] && Boolean(errors[item.fieldKey])}
        helperText={touched[item.fieldKey] && errors[item.fieldKey]}
        onChange={setFieldValue}
        setFieldTouched={setFieldTouched}
        listIndex={listIndex ?? props?.nextItemIndex}
        preventSelectData={selectPreventOptions}
        isModalField={true}
      />
    )
  }

  return (
    <FormModal fullWidth maxWidth='xl' open={props.isVisible} onClose={() => props.onVisibleChange(false)}>
      <Grid alignItems="center" justifyContent="flex-start" container direction="row" spacing={{ xs: 2, md: 3 }} columns={{ xs: 3, sm: 6, md: 12 }}>
        {
          props.fields.map((item, index) => (
            LocalRenderGrid({ item, index })
          ))
        }

      </Grid>
      <MediumHeightDivider />
      <StyledButton onClick={handleSubmit}>
        {isModifying ? 'Guardar' : 'Confirmar'}
      </StyledButton>
      <SmallHeightDivider />
    </FormModal>
  );
}

export default memo(ModalForm);
